
import React, { Component } from 'react'; 
import {Tabs, Tab, Spinner} from 'react-bootstrap';
import '../../Resources/css/formbuilder.css';
import FormElements from './FormElements.js';
import AuditForm from './AuditForm.js';
import FormMapping from './FormMapping.js'; 
import MappedForm from './MappedForm.js'; 
import {FormElementAction, FormElementAdditionalFieldsEdit, formtemplateMapExist,
  FormElementAdd, FormElementDelete, FormElementActive, FormTemplateActionAdd,MappedList,
  FormElementEdit, FormTemplateAction, FormTemplateActionEdit,ReAssignAPI,
  FormElementUpdateSave, templateNamesList, AuditTypeList, formTemplateDelete, closeModalPopUp,
  formTemplateMapping} from './FormAction';
import {InventoryUserMappedAction, TokenValidation} from '../Dashboard/UserActions';
import ShowModalPopUp from '../ShowModalPopUp';
import { connect } from 'react-redux';
import _ from 'lodash';

 class Formindex extends Component {
  constructor(props){
    super(props)
    this.state={
    }
  }
  componentDidMount(){  
    this.props.TokenValidation()      
  }
  loadTabContent = (prop) => {
    this.setState({key:prop})
  } 
  ScreensComp = () =>{        
    const{template_action, mapSucess, loginAction, payload, nameList, inventoryMapped, mappedData} = _.cloneDeep(this.props);    
    const{key} = this.state
    if(!_.isEmpty(loginAction)){
    let moduleAccess = _.find(loginAction.modulescreens, {"moduleUId": "DYNAMIC_FORM"})
    let returnObj =[]
    _.map(moduleAccess.screens, (obj) =>{ 
        if(obj.screenUId === "FORM_ELEMENTS"){ 
          returnObj.push(<Tab eventKey="FORM_ELEMENTS" title="SCREEN ELEMENTS" key={1}>            
            <FormElements payload={payload} function={this.props}/>              
          </Tab>)}
        if(obj.screenUId === "AUDIT_FORM"){ 
          returnObj.push(<Tab eventKey="AUDIT_FORM" title="TEMPLATE MANAGEMENT" key={2}>          
          <AuditForm function={this.props} templatepayload={template_action} nameList={nameList} payload={payload}
          accessPermission={obj.accessPermission} /> 
          </Tab>)}
        if(obj.screenUId === "FORM_MAPPING"){ 
          returnObj.push(<Tab eventKey="FORM_MAPPING" title="TEMPLATE MAPPING" key={3}>         
          <FormMapping inventory={inventoryMapped} nameList={nameList}  mapSucess={mapSucess} templatepayload={template_action} 
          function={this.props}/> 
          </Tab>)}
        if(obj.screenUId === "MAPPED_FORMS"){ 
          returnObj.push(<Tab eventKey="MAPPED_FORMS" title="MAPPED TEMPLATES" key={4}>        
          <MappedForm mappedData={mappedData}  payload={payload} nameList={nameList} 
          accessPermission={obj.accessPermission} 
          function={this.props}/>      </Tab>)}
    })
    returnObj =	_.sortBy(returnObj, ['key'])
   return (<Tabs defaultActiveKey={ moduleAccess.screens[0].screenUId} transition={false} activeKey={key ? key : returnObj[0].props.eventKey} unmountOnExit={true}
   id="noanim-tab-example" onSelect={(eventKey)=>this.loadTabContent(eventKey)}>
   {returnObj}</Tabs>)
    }
     
  } 

  render(){
    let style= true
		if(typeof this.props.size !== 'undefined'){
			style = this.props.size
    }
    return(      
      <div className={(style) ? 'user' : "userSmall"}>  
      {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null} 
        {(this.props.showerror === true) ?
        <ShowModalPopUp message={this.props.errmessage} 
        falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
        {this.ScreensComp()}
      </div>)
  
  }
}
function mapStateToProps(state){  
  return{
   payload: state.FormReducer.result,
   template_action: state.FormReducer.formbuilder,
   inventoryMapped: state.UserReducer.inventoryMapped,
   mappedData: state.FormReducer.mappedData,
   size: state.UserReducer.large,
   nameList: state.FormReducer.templateNameList,
   auditTypes: state.FormReducer.auditTypes,
   mapSucess: state.FormReducer.mapSucess,
   showerror: state.FormReducer.showerror, 
   isPending: state.FormReducer.isPending, 
   errmessage: state.FormReducer.errmessage,     
   loginAction: state.LoginReducer.loginAction,  
   showModalLogin: state.UserReducer.showModalLogin,
  }  
}

const mapDispatchToProps = (dispatch) => ({
  action: () => dispatch(FormElementAction()),
  actioninventoryUserMapped:  () =>dispatch(InventoryUserMappedAction()),  
  actionTemplate: () => dispatch(FormTemplateAction()),
  addValues: (a, b) => dispatch(FormElementAdd(a, b)),
  deleteValues: (a, b) => dispatch(FormElementDelete(a, b)),
  deleteTemplate: (a) => dispatch(formTemplateDelete(a)),
  editValues: (a, b, c, i) => dispatch(FormElementEdit(a, b, c, i)),
  activeValues: (a, b) => dispatch(FormElementActive(a, b)),
  activetemplateAdd: (a, b, c) => dispatch(FormTemplateActionAdd(a, b, c)),
  activetemplateEdit: (a, b, c) => dispatch(FormTemplateActionEdit(a, b, c)),
  TemplateMapping: (a, b, c) => dispatch(formTemplateMapping(a, b, c)),
  formElementsSaveAction: (a) => dispatch(FormElementUpdateSave(a)),
  AdditionalFieldEdit: (a, b, c) => dispatch(FormElementAdditionalFieldsEdit(a, b, c)),
  MappedListaction: () => dispatch(MappedList()),  
  templateNames: () => dispatch(templateNamesList()),
  AuditTypeList: () => dispatch(AuditTypeList()),
  formTemplateExist: (a) => dispatch(formtemplateMapExist(a)),    
  closeModalPopUp: () => dispatch(closeModalPopUp()),
  ReAssignAPI : (a) => dispatch(ReAssignAPI(a)),
  TokenValidation : (a) => dispatch(TokenValidation(a))

})

export default connect(mapStateToProps, mapDispatchToProps)(Formindex);